module.exports = __webpack_public_path__ + "static/img/200281.47815573.png";